var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"cell-multi-line"},[_vm._v(_vm._s(_vm.date))]),(_vm.time)?_c('span',{staticClass:"cell-multi-line"},[_vm._v(_vm._s(_vm.time))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }